import { Dialog, DialogContent } from '@mui/material';

export const Modal = ({
  children,
  open,
  onClose,
  maxWidth = false,
}: {
  children: React.JSX.Element;
  open: boolean;
  onClose?: () => void;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}) => {
  return (
    <Dialog data-testid="modal" open={open} onClose={onClose} maxWidth={maxWidth}>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
